import { url } from "./url"
export const previewTitle = (item) => {
  let title =
    item.content?.name ||
    item.content?.title ||
    item.content?.label ||
    item.content?.id

  if (!title && item.content) {
    //go through all values and find one that is other than the .type

    title = Object.values(item.content).find((value) => {
      if (typeof value !== "string") return false
      return value !== item.content.type && !value.startsWith("/")
    })

  }
  
  // Ensure we always return a string, never an object
  if (typeof title === 'object' && title !== null) {
    // Try to extract meaningful string values from common object properties
    const stringValue = title.name || title.label || title.value || title.title || title.id
    if (stringValue && typeof stringValue === 'string') return stringValue
    // If it's an array, join the strings
    if (Array.isArray(title)) {
      return title.filter(item => typeof item === 'string').join(', ') || 'Array content'
    }
    // Last resort - return a meaningful description instead of [object Object]
    return 'Complex content'
  }
  
  return title || 'Untitled'
}

export const previewImage = (item) => {
  if (!item) return

  const searchIn = item.content ?? item

  let { image } = searchIn
  //if there is no image, try to find a value that starts with images/ and use it as a preview
  if (!image) {
    image = Object.values(searchIn).find(
      (value) => typeof value === "string" && value.startsWith("images/")
    )
  }

  //get the first image if it is an array
  if (Array.isArray(image)) image = image[0]
  image = url(image)
  return image
}
